// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPGLoan,
  IsApplicantSameAsPrincipal,
  HasPgFiledTaxesYearsAgo,
} from '../rules';

class PgTaxes1YearAgoRuleset implements Ruleset {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isPGLoan = IsPGLoan.evaluate(data);
    const applicantSameAsPrincipal = IsApplicantSameAsPrincipal.setPrincipalId(
      this.principalId
    ).evaluate(data);
    const hasPgFiledTaxes1YearAgo = HasPgFiledTaxesYearsAgo.setPrincipalId(
      this.principalId
    )
      .setYears(1)
      .setAnswer('Yes')
      .evaluate(data);

    const hasPGFiledTaxes1YearAgoNotAnswered =
      HasPgFiledTaxesYearsAgo.setPrincipalId(this.principalId)
        .setYears(1)
        .setAnswer(null)
        .evaluate(data);

    return isPGLoan &&
      applicantSameAsPrincipal &&
      (hasPgFiledTaxes1YearAgo || hasPGFiledTaxes1YearAgoNotAnswered)
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PgTaxes1YearAgoRuleset();
